<template>

<div>

  <LDBsTable
    url="service-types"
    defaultSort="id"
    defaultOrder="asc"
    :query="query"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-6">
      <label>{{ $t('name') }}</label>
      <input 
        type="text"
        class="form-control"
        id="name"
        name="name"
        :placeholder="$t('type_name')"
        v-model="query.name"
      >
    </div>

    <div class="form-group col-lg-6">
      <label for="active">{{ $t('active') }}</label>
        <vue-select
          class="bg-white"
          name='isActive'
          :placeholder="$t('select_a_item')"
          label="label"
          :options="[{ label: 'SIM', value: true }, { label: 'NÃO', value: false }]"
          v-model="query.isActive"
          :reduce="active => active.value"
          :select-on-tab='true'
        />
    </div>
  </LDBsTable>

</div>

</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'

export default {
  name: 'ServiceTypesList',
  components: {
    LDBsTable
  },
  data () {
    return {
      columns: [
        {
          title: this.$t('name'),
          field: 'name',
          sortable: true
        },
        {
          title: this.$t('active'),
          field: 'isActive',
          formatter: function(value) {
            return value
              ? 'SIM' 
              : 'NÃO'
          },
          sortable: true
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value) {
            return `<a href="#/main/servicetype/${value}" class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"><i class="fas fa-pen"></i></a>`
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'tipos_de_servico' }
      },
      query: {
        name: '',
        isActive: ''
      }
    }
  },
  methods: {
    clear() {
      this.query.name = ''
      this.query.isActive = ''
    }
  }
}

</script>